// export interface Request {
//   requestId: string;
//   customer: string;         // customer Mailaddress

import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';
import { Customer } from '../settings/customer-settings/customer-settings.model';
import { Airline } from '../shared/shared.models';

//   finalDestination: string;
//   numberOfParcels: number;
//   availableExOrigin: Date;
//   weight: string;
//   chargeableWeight: string;
//   specialCargoRequest: string;
//   note: string;
//   targetRate: string;
// }

export interface Request {
  closed: boolean;
  availableExOrigin: Date;
  chargeableWeight: 0;
  createdDate: Date;
  customer: Customer;
  erateSheetAirlines: Airline[];
  finalDestination: string;
  id: number;
  lastUpdated: Date;
  messages: Message[];
  note: string;
  numberOfParcels: 0;
  requestID: string;
  requestStatus: Status;
  specialCargoRequest: string;
  targetRate: number;
  weight: number;
  stackable: boolean;
  sellingPrice: number;
  purchasePrice: number;
  awbID: string;
  editedMessages: string[];
  noteAdmin: string;
  newMessages: string[];
  requestAttachmentDetails?: RequestAttachmentDetails;
  partRequestID: string;
  partPrimaryRequestID: number;
}

export interface RequestAttachmentDetails {
  id?: number;
  requestId?: string;
  smartInfos: RequestAttachmentSmartInfos[];
}

export interface RequestAttachmentSmartInfos {
  id?: number;
  name: string;
  contentType: string;
  size: number;
}

export interface RequestAttachment {
  id?: number;
  name: string;
  contentType: string;
  size: number;
  contentBytes: string;
  requestId?: string;
}

export enum Status {
  NEW = 'NEW',
  CLOSED = 'CLOSED',
  WAITING_FOR_ANSWER = 'WAITING_FOR_ANSWER',
  WAITING_FOR_ACTION = 'WAITING_FOR_ACTION',
  INVOICED = 'INVOICED',
  NOT_INVOICED = 'NOT_INVOICED'
}

export interface Detail {
  date: Date;
  subject: string;
}

export interface Message {
  bccRecipients: any[];
  body: Body;
  bodyPreview: string;
  categories: any[];
  ccRecipients: any[];
  changeKey: string;
  conversationId: string;
  conversationIndex: string;
  createdDateTime: string;
  flag: Flag;
  from: From;
  hasAttachments: boolean;
  id: string;
  importance: string;
  inferenceClassification: string;
  internetMessageId: string;
  isDeliveryReceiptRequested: boolean;
  isDraft: boolean;
  isRead: boolean;
  isReadReceiptRequested: boolean;
  lastModifiedDateTime: string;
  parentFolderId: string;
  receivedDateTime: string;
  replyTo: string;
  sender: Sender;
  sentDateTime: string;
  subject: string;
  toRecipients: ToRecipient[];
  webLink: string;
  attachments: Attachment[];
}


export enum MessageType {
  AIRLINE = 'AIRLINE',
  CUSTOMER = 'CUSTOMER',
  BROKER = 'BROKER',
  AIRLINEWITHERATESHEET = 'AIRLINEWITHERATESHEET',
  EMAIL = 'EMAIL'
}

export interface AttachmentDetail {
  id: string;
  messageId: string;
  smartInfos: SmartInfo[];
}

export interface SmartInfo{
  attachmentId: string;
  contentType: string;
  id: string;
  inline: boolean;
  name: string;
  size: number;
}

export interface Attachment {

  odataMediaContentType: string;
  odataType: string;
  contentBytes: string;
  contentId: string;
  contentLocation: string;
  contentType: string;
  id: string;
  isInline: boolean;
  lastModifiedDateTime: Date;
  name: string;
  size: number;

  additionalProperties: AdditionalProperties[];
}

interface AdditionalProperties {
}


export interface Flag {
  flagStatus: string;
}

export interface Body {
  content: string;
  contentType: string;
}

export interface From {
  emailAddress: EmailAddress_;
}

export interface Sender {
  emailAddress: EmailAddress__;
}

export interface ToRecipient {
  emailAddress: EmailAddress;
}

export interface EmailAddress {
  address: string;
  name: string;
}

export interface EmailAddress_ {
  address: string;
  name: string;
}

export interface EmailAddress__ {
  address: string;
  name: string;
}
